{
  "ancillaries": {
    "overlappingServicesNotification": {
      "keepSelection": ""
    }
  }
}
